import React from 'react';
import { format } from 'date-fns';
import PropTypes from 'prop-types';

import StarRating from '../../../../library/star-rating/star-rating';
import {
  CheckCircleSolidIcon,
  MapMarkerAltSolidIcon,
  TimesCircleSolidIcon
} from '../../../../shared/icons/icons';
import RatingGauge from '../../../rating-gauge/rating-gauge';
import ReviewFeedback from '../review-feedback/review-feedback';

import './review.scss';

function Review(props) {
  const {
    answers,
    city,
    comments,
    date,
    details,
    heading,
    helpfulCount,
    id,
    isFeedbackSubmitted,
    isRecommended,
    notHelpfulCount,
    notRecommendedMessage,
    onHelpfulClick,
    rating,
    recommendedMessage,
    reviewerName,
    state,
    subHeading
  } = props;

  return (
    <div styleName="container">
      <div styleName="reviewer">
        <div styleName="heading">
          {heading}
          <br />
          {subHeading && <span styleName="sub-heading">{subHeading}</span>}
        </div>

        <div styleName="reviewer-rating">
          <StarRating rating={rating} />
        </div>

        {typeof reviewerName === 'string' && (
          <span styleName="reviewer-name">{reviewerName || 'Anonymous'}</span>
        )}

        {city && state && (
          <span>
            <MapMarkerAltSolidIcon />
            &nbsp;{city}, {state}
          </span>
        )}
      </div>

      <div styleName="details">
        <div styleName="recommendation">
          {isRecommended ? (
            <span styleName="recommended">
              <CheckCircleSolidIcon styleName="recommend-icon" />
              {recommendedMessage && (
                <span styleName="recommend-message">{recommendedMessage}</span>
              )}
            </span>
          ) : (
            <span styleName="not-recommended">
              <TimesCircleSolidIcon styleName="recommend-icon" />
              {notRecommendedMessage && (
                <span styleName="recommend-message">
                  {notRecommendedMessage}
                </span>
              )}
            </span>
          )}
          <span styleName="date">{format(date || '', 'M/D/YYYY')}</span>
        </div>

        {Array.isArray(details) && (
          <ul styleName="details-list">
            {details.map((detail, idx) => (
              <li key={`dl-${idx}`} styleName="details-list-item">
                <span styleName="detail-label">{detail?.label}:</span>
                {detail?.value}
              </li>
            ))}
          </ul>
        )}

        <div styleName="rating-breakdown">
          {Array.isArray(answers) &&
            answers.map((answer, idx) => (
              <RatingGauge
                key={`rba-${idx}`}
                label={answer.label}
                rating={answer.rating}
                styleName="rating-gauge"
              />
            ))}
        </div>

        <p
          dangerouslySetInnerHTML={{
            __html: comments
          }}
          styleName="comments"
        />

        <ReviewFeedback
          helpfulCount={helpfulCount}
          id={id}
          isFeedbackSubmitted={isFeedbackSubmitted}
          notHelpfulCount={notHelpfulCount}
          onHelpfulClick={onHelpfulClick}
        />
      </div>
    </div>
  );
}

Review.propTypes = {
  answers: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      rating: PropTypes.number
    })
  ),
  city: PropTypes.string,
  comments: PropTypes.string,
  date: PropTypes.string,
  details: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string
    })
  ),
  heading: PropTypes.string,
  helpfulCount: PropTypes.number,
  id: PropTypes.string,
  isFeedbackSubmitted: PropTypes.bool,
  isRecommended: PropTypes.bool,
  notHelpfulCount: PropTypes.number,
  notRecommendedMessage: PropTypes.string,
  onHelpfulClick: PropTypes.func,
  rating: PropTypes.number,
  recommendedMessage: PropTypes.string,
  reviewerName: PropTypes.string,
  state: PropTypes.string,
  subHeading: PropTypes.string
};

export default Review;
